import { toast } from "sonner";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  getExamRequestsByPatient as getExamRequestsByPatientService,
  createExamRequest as createExamRequestService,
} from "../../services/examsRequests";
import { getStoragePatient } from "../../utils/storageUtils";
import * as types from "./types";
import { adaptResponseError } from "../../utils/utils";

/**
 * Sagas du domaine ExamRequest.
 *
 * <p>POST /request-exam → Long (id) ; on rafraîchit la liste du patient
 * (payload.patientId ou patient courant en storage) après création.
 */

function* createExamRequest({ payload }) {
  try {
    const result = yield call(createExamRequestService, payload);
    if (!result?.ok) {
      // Le toast est déjà émis par `apiRequest` (notifyApiError).
      yield put({
        type: types.CREATE_REQUEST_EXAM_FAILURE,
        payload: adaptResponseError(result || {}),
      });
      return;
    }
    toast.success("Demande d'examen créée avec succès");
    yield put({
      type: types.CREATE_REQUEST_EXAM_SUCCESS,
      payload: { id: result.data },
    });

    const patientId = payload?.patientId ?? getStoragePatient()?.id;
    if (patientId != null) {
      yield put({
        type: types.GET_REQUEST_EXAMS_REQUEST,
        payload: { patientId },
      });
    }
  } catch (error) {
    console.error("CreateExamRequestSagaErr: ", error);
    yield put({
      type: types.CREATE_REQUEST_EXAM_FAILURE,
      payload: [{ message: error?.message || "Erreur inattendue" }],
    });
  }
}

function* getExamRequestsByPatient({ payload }) {
  try {
    const patientId = payload?.patientId;
    if (patientId == null) {
      yield put({ type: types.GET_REQUEST_EXAMS_FAILURE, payload: [] });
      return;
    }
    const result = yield call(getExamRequestsByPatientService, patientId);
    if (!result?.ok) {
      yield put({ type: types.GET_REQUEST_EXAMS_FAILURE, payload: [] });
      return;
    }
    yield put({
      type: types.GET_REQUEST_EXAMS_SUCCESS,
      payload: Array.isArray(result.data) ? result.data : [],
    });
  } catch (error) {
    console.error("GetExamRequestsByPatientSagaErr: ", error);
    yield put({ type: types.GET_REQUEST_EXAMS_FAILURE, payload: [] });
  }
}

export default function* ExamsRequestsSaga() {
  yield takeLatest(types.CREATE_REQUEST_EXAM_REQUEST, createExamRequest);
  yield takeLatest(types.GET_REQUEST_EXAMS_REQUEST, getExamRequestsByPatient);
}
